import { atomWithReset } from "jotai/utils";
export const componentsLoaderAtom = atomWithReset(false);
